import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Loading.css";
import facts from "../pages/loadingfacts.json";
import tuktuk from "../assets/General/TukTuk.png";
import logo from "../assets/General/logo.png";

const DEFAULT_TOTAL_TIME = 4000;
const TICK_INTERVAL_MS = 40;

export default function Loading() {
  const goToPage = useNavigate();
  const location = useLocation();

  const targetPath = location.state?.to || "/home";
  const requestedTotalTime = Number(location.state?.time);
  const totalTime =
    Number.isFinite(requestedTotalTime) && requestedTotalTime > 0
      ? requestedTotalTime
      : DEFAULT_TOTAL_TIME;

  const [progress, setProgress] = useState(0);

  const randomFact = useMemo(
    () => facts[Math.floor(Math.random() * facts.length)],
    []
  );

  const intervalRef = useRef(null);
  const fallbackTimeoutRef = useRef(null);
  const hasNavigatedRef = useRef(false);
  const startTimestampRef = useRef(0);

  useEffect(() => {
    hasNavigatedRef.current = false;
    setProgress(0);
    startTimestampRef.current = Date.now();

    function finishLoading() {
      if (hasNavigatedRef.current) return;

      hasNavigatedRef.current = true;
      setProgress(100);
      goToPage(targetPath, { replace: true });
    }

    function updateProgress() {
      const elapsedTime = Date.now() - startTimestampRef.current;
      const nextProgress = Math.min(100, (elapsedTime / totalTime) * 100);

      setProgress(nextProgress);

      if (elapsedTime >= totalTime) {
        finishLoading();
      }
    }

    // run it once straight away so the bar does not wait for the first interval
    updateProgress();
    intervalRef.current = window.setInterval(updateProgress, TICK_INTERVAL_MS);

    // this is a backup in case the interval gets delayed or the tab behaves oddly
    fallbackTimeoutRef.current = window.setTimeout(
      finishLoading,
      totalTime + 150
    );

    return () => {
      if (intervalRef.current) {
        window.clearInterval(intervalRef.current);
        intervalRef.current = null;
      }

      if (fallbackTimeoutRef.current) {
        window.clearTimeout(fallbackTimeoutRef.current);
        fallbackTimeoutRef.current = null;
      }
    };
  }, [goToPage, targetPath, totalTime, location.key]);

  return (
    <div className="loadingPage">
      <img className="logo" src={logo} alt="Explore Lanka Logo" />

      <div className="loadingCard">
        <div className="loadingTitle">Loading…</div>
        <div className="loadingFact">{randomFact}</div>

        <div
          className="barOuter"
          role="progressbar"
          aria-valuenow={Math.round(progress)}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          <div className="barFill" style={{ width: `${progress}%` }} />

          <img
            src={tuktuk}
            alt="Tuk Tuk"
            className="tukTuk"
            style={{ left: `${progress}%` }}
          />
        </div>

        <div className="loadingHint">Preparing your adventure!</div>
      </div>
    </div>
  );
}